import React from "react";

import { ORDER_APP_PAGE_SIZE } from "../../../constants";

/**
 * @param {Object} props
 * @param {number} props.ordersCount
 * @returns {React.JSX.Element}
 */
export default function Instructions({ ordersCount }) {
  return (
    <div id="OrderStatusUserInstructions">
      <ul>
        <li>
          STN (SEWP Tracking Number) is a unique number related to an order. You can have multiple order numbers
          associated with one SEWP Tracking Number.
        </li>
        <li>View the Order Details page by selecting an STN under the SEWP Tracking Number (STN) column.</li>
        <li>
          View the Contract Holder (CH) detail page by selecting a Contract Holder name under the Contract Holder (CH)
          column.
        </li>
        <li>
          E-mail the Contract Holder regarding your order by selecting "Contract Holder &amp; SEWP" under Send E-Mail
          column.
        </li>
        <li>E-mail SEWP for help regarding your order by selecting "SEWP Only" under Send E-Mail column.</li>
        <li>Sort any column by selecting the column heading (in ascending or descending order).</li>
        {ordersCount > ORDER_APP_PAGE_SIZE && (
          <li>View more than 10 orders per page by selecting "View All Orders".</li>
        )}
      </ul>
      <div id="video_OrderStatus" data-videodiv-directive="">
        <a href="/documents/OrderStatusTool.mp4" target="_blank">
          <img src="/images/PLAY_50px.png" alt="PLAY" /> Watch our 3-minute clip!
        </a>
      </div>
    </div>
  );
}
